import ContestEmptyStateCard from '~/domains/contest/domains/common/components/ContestEmptyStateCard/ContestEmptyStateCard';

import useMyContestsEmptyConfig from '../hooks/useMyContestsEmptyConfig';

import type { ContestTab } from '../hooks/useEntriesTabsProps';

function MyContestsEmpty({ contestTab }: { contestTab: ContestTab }) {
  const config = useMyContestsEmptyConfig({ contestTab });

  return (
    <ContestEmptyStateCard
      title={config.title}
      description={config.text}
      actions={config.actions}
      icon={config?.icon}
    />
  );
}

export default MyContestsEmpty;
